module.exports = __webpack_public_path__ + "img/Qualityserve-top.278d9533.png";